import { ComponentProps, ReactNode } from 'react';

import { mergeClasses } from '@/utils';

import { BUTTON_VARIANTS, ICON_VARIANTS } from './Button.constants';

interface IButton extends Omit<ComponentProps<'button'>, 'color'> {
  buttonStyle?: 'filled' | 'outline' | 'textlink';
  buttonColor?: 'primary' | 'neutral' | 'error' | 'success' | 'warning' | 'icon';
  size?: 'sm' | 'default' | 'lg';
  borderRadius?: 'rounded' | 'soft';
  prefixIcon?: ReactNode;
  suffixIcon?: ReactNode;
  active?: boolean;
}

const Button = ({
  className,
  buttonStyle = 'filled',
  buttonColor = 'primary',
  size = 'default',
  borderRadius = 'rounded',
  prefixIcon,
  suffixIcon,
  active,
  children,
  ...props
}: IButton) => {
  return (
    <button
      data-slot="button"
      data-style={buttonStyle}
      data-color={buttonColor}
      data-size={size}
      data-border-radius={borderRadius}
      data-active={active}
      className={mergeClasses(
        BUTTON_VARIANTS({ style: buttonStyle, buttonColor, size, borderRadius }),
        className,
      )}
      {...props}
    >
      {prefixIcon ? (
        <span className={mergeClasses(ICON_VARIANTS({ size }))}>{prefixIcon}</span>
      ) : null}
      {children}
      {suffixIcon ? (
        <span className={mergeClasses(ICON_VARIANTS({ size }))}>{suffixIcon}</span>
      ) : null}
    </button>
  );
};

export { Button, BUTTON_VARIANTS, ICON_VARIANTS, type IButton };
